import { useEffect, useRef, useState } from "react";
import { roomsData } from "@/mocks/innData";

export default function RoomsPreviewSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-20 md:py-28 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div
          className={`flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12 md:mb-16 transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <h2 className="font-serif text-3xl md:text-4xl text-stone-900">
            お部屋と過ごし方
          </h2>
          <p className="text-stone-500 text-sm md:text-base">
            3室だけの特別な空間
          </p>
        </div>

        {/* Room cards - horizontal scroll on mobile */}
        <div className="flex gap-4 md:gap-6 overflow-x-auto pb-4 md:pb-0 md:overflow-visible snap-x snap-mandatory scrollbar-hide">
          {roomsData.map((room, i) => (
            <div
              key={room.id}
              className={`group flex-shrink-0 w-[85vw] sm:w-[45vw] md:w-full md:flex-1 snap-start rounded-2xl overflow-hidden transition-all duration-700 ${
                visible
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${(i + 1) * 150}ms` }}
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <img
                  src={room.image}
                  alt={`温泉民宿宝栄丸の${room.name}（${room.subtitle}）`}
                  width={800}
                  height={1000}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                {/* Room info */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent" />
                <div className="sr-only">
                  <h3>{room.name}</h3>
                  <p>{room.subtitle}</p>
                  <p>{room.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}